import React from 'react';
import { SortTypes } from '../../types/sort.types';
import styled from 'styled-components';

export interface SortArrowsIconProps {
  sortOrder: string;
  svgId?: string;
}

export const StyledSortArrows = styled.svg``;

const StyledSortArrowsGradient = styled.linearGradient``;

const SortArrowsIcon = ({ sortOrder, svgId = 'a' }: SortArrowsIconProps) => {
  const isSortEnabled = sortOrder !== SortTypes.DEFAULT;
  const isSortDirectionDesc = sortOrder === SortTypes.DESC;

  return (
    <StyledSortArrows
      width="12"
      height="16"
      viewBox="0 0 14 18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.1487 3.14094L4.3587 0.360944C4.1587 0.170944 3.8487 0.170944 3.6487 0.360944L0.858702 3.14094C0.538702 3.45094 0.768702 3.99094 1.2087 3.99094L3.0087 3.99094L3.0087 10.0009C3.0087 10.5509 3.4587 11.0009 4.0087 11.0009C4.5587 11.0009 5.0087 10.5509 5.0087 10.0009L5.0087 3.99094L6.7987 3.99094C7.2487 3.99094 7.4687 3.45094 7.1487 3.14094ZM10.3587 17.6509L13.1487 14.8709C13.4687 14.5609 13.2387 14.0209 12.7987 14.0209L11.0087 14.0209L11.0087 8.00094C11.0087 7.45094 10.5587 7.00094 10.0087 7.00094C9.4587 7.00094 9.0087 7.45094 9.0087 8.00094L9.0087 14.0109L7.2187 14.0109C6.7687 14.0109 6.5487 14.5509 6.8687 14.8609L9.6587 17.6409C9.8487 17.8409 10.1687 17.8409 10.3587 17.6509Z"
        fill={isSortEnabled ? `url(#${svgId})` : 'currentColor'}
      />
      <defs>
        {isSortEnabled && (
          <StyledSortArrowsGradient
            id={svgId}
            x1={isSortDirectionDesc ? '.50653' : '.5495'}
            x2={isSortDirectionDesc ? '1' : '.51434'}
            y1={isSortDirectionDesc ? '.42578' : '.53906'}
            y2={isSortDirectionDesc ? '.88281' : '.50391'}
          >
            <stop
              stopColor="currentColor"
              offset={isSortDirectionDesc ? '.069031' : '0'}
            />
            <stop
              stopColor="#206FE2"
              offset={isSortDirectionDesc ? '.20966' : '1'}
            />
          </StyledSortArrowsGradient>
        )}
      </defs>
    </StyledSortArrows>
  );
};

export default SortArrowsIcon;
